import * as React from 'react';

import { Badge } from '@workspace/ui/components/badge';

import { BlurFade } from './blur-fade';

export type SiteHeadingProps = {
  badge?: React.ReactNode;
  title?: React.ReactNode;
  description?: React.ReactNode;
  isSecondary?: boolean;
};

export function SiteHeading({
  badge,
  title,
  description,
  isSecondary
}: SiteHeadingProps): React.JSX.Element {
  return (
    <div className="mx-auto flex max-w-5xl flex-col items-center text-center">
      {badge && (
        <BlurFade inView>
          <Badge
            variant="primary"
            className={`${isSecondary ? 'mb-6' : 'mb-7'} rounded-full px-3 py-1 text-xs font-medium shadow-xs bg-videomule-light-green dark:bg-videomule-green/10`}
          >
            {badge}
          </Badge>
        </BlurFade>
      )}
      {title && (
        <BlurFade
          inView
          delay={0.1}
        >
          {isSecondary ? (
            <h2 className="text-pretty text-4xl font-bold lg:text-5xl">
              {title}
            </h2>
          ) : (
            <h1 className="text-pretty text-5xl font-bold lg:text-6xl">
              {title}
            </h1>
          )}
        </BlurFade>
      )}
      {description && (
        <BlurFade
          inView
          delay={0.2}
        >
          <p className="text-muted-foreground text-base sm:text-lg lg:text-xl mb-10 sm:mb-12 lg:mb-15 max-w-3xl mx-auto leading-relaxed mt-4">
            {description}
          </p>
        </BlurFade>
      )}
    </div>
  );
}
